import DeepArray from '#/types/DeepArray';
import { isType } from './typeGuards';

const deepMap = <T = unknown, R = T>(array: DeepArray<T>, map: (value: T) => R): DeepArray<R> => {
  return array.map((item) => {
    return isType(item, 'array') ? deepMap(item, map) : map(item);
  });
};

export default deepMap;
